const redo = {
    svg: '<svg style="width:1.00rem; height:1.00rem;" viewBox="0 0 16 16"><path d="m10.349 1.2 4.495 4.54-4.416 4.46-1.06-1.049 2.643-2.671H6.074c-1.708 0-3.114 1.262-3.3 2.884l-.015.182-.005.184c0 1.794 1.486 3.25 3.32 3.25H10.7v1.43H6.074c-2.636 0-4.774-2.094-4.774-4.68 0-2.585 2.138-4.68 4.774-4.68h5.99L9.289 2.249z"/></svg>',
};

export { redo as default };
